export default "__VITE_ASSET__39bc7b35__"